/**
 * External dependencies
 */
import React, { useState } from "react";
import { find, map, get } from "lodash";
import { DropdownLinkV2 } from "components/dropdown-link-v2";

/**
 * Style dependencies
 */
import "./styles.scss";

const DropdownSelect = ({ options, onChange, selected, activatorProps }) => {
  const [selectedOption, setSelectedOption] = useState(selected);

  let _selected = find(options, { value: selectedOption });

  const handleOnChange = (selected) => {
    setSelectedOption(selected);
    onChange && onChange(selected);
  };

  return (
    <DropdownLinkV2
      activatorProps={{
        compact: true,
        ...activatorProps,
      }}
      className="dropdown-select"
      title={get(_selected, "label", "Select option")}
      items={map(options, (option) => ({
        key: option.key || option.value,
        onClick: () => handleOnChange(option.value),
        label: option.label,
        active: option.value === selectedOption,
      }))}
    ></DropdownLinkV2>
  );
};

export default DropdownSelect;
